// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__3w5b4","imageUploader":"EGiftCard_imageUploader__wViBZ"};